module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "mb-4",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [(_vm.mediaError.errors) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.mediaError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropbox",
    class: {
      hovered: _vm.hoverDropbox
    }
  }, [(_vm.isUploading == false) ? _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave,
      "drop": _vm.dragLeave,
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadingFileCount < 1) ? _c('div', {
    staticClass: "dropbox-info"
  }, [_vm._v("\n\t\t\t\tPlaats uw bestanden hier om te beginnen\n\t\t\t\t"), _c('br'), _vm._v(" of klik om te selecteren\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.uploadingFileCount > 0) ? _c('div', {
    staticClass: "row dropbox-info justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-progress', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.uploadingStatus,
      "variant": "info",
      "striped": "",
      "animated": "",
      "height": "2rem"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.fileCount - _vm.uploadingFileCount) + " van " + _vm._s(_vm.fileCount) + " bestanden aan het uploaden...\n\t\t\t\t")], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row media"
  }, _vm._l((_vm.item.media), function(media, index) {
    return _c('div', {
      key: index,
      staticClass: "col col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-6 media-item"
    }, [_c('figure', {
      staticClass: "media-item-image",
      style: ({
        backgroundImage: 'url(' + _vm.medium(media.url) + ')'
      })
    }, [_c('button', {
      staticClass: "media-item-image-delete",
      attrs: {
        "type": "button",
        "hidden": _vm.isDeleting && _vm.deletingKey == index
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteModal({
            itemId: _vm.item.id,
            mediaId: media.id,
            mediaKey: index
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    }), _vm._v(" Verwijder")]), _vm._v(" "), (_vm.isDeleting && _vm.deletingKey == index) ? _c('div', {
      staticClass: "media-item-image-loader"
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.$t('media.deleteModalMessage'),
      "item": _vm.selectedDeleteMedia,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteMediaItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f06010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/Form/ItemMedia.vue
// module id = 1318
// module chunks = 1